import { useEffect } from "react";
import { useParams } from "react-router-dom";

import * as Sentry from "@sentry/browser";

import FullScreenLoader from "@/components/FullScreenLoader";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

export const CustomRedirectScreen = ({
  question,
}: Pick<QuizQuestionProps<unknown>, "question">) => {
  const { voucherId } = useParams<{
    voucherId: string;
  }>();
  const { redirectUrl, appendVoucherId = false } = question.attributes;
  const resolvedRedirectUrl =
    redirectUrl && (!appendVoucherId || voucherId)
      ? appendVoucherId
        ? `${redirectUrl.replace(/\/$/, "")}/${encodeURIComponent(voucherId ?? "")}`
        : redirectUrl
      : null;

  useEffect(() => {
    if (!resolvedRedirectUrl) {
      Sentry.captureException(
        new Error("Custom redirect screen is missing its redirect target"),
      );
      return;
    }

    window.location.replace(
      `${import.meta.env.VITE_FRONT_BASE_URL}${resolvedRedirectUrl}`,
    );
  }, [resolvedRedirectUrl]);

  return <FullScreenLoader isLoading />;
};
